import AbstractController from "../../../vendors/services/abstractController";
import LoginService from "../../services/LoginService";
import LoginFilter from "../../../vendors/pages/Auth/model/LoginFilter";
import ToastService from "../../../vendors/services/toastService";
import EventoService from "../../services/evento.service";
import {
  configurarSessaoEventoInterno,
  encerrarSessaoEventoInterno,
} from "../../shared/utils/EventoInternoUtil";

export default class ModalLoginInternoController extends AbstractController {
  private loginService = new LoginService();
  private eventoService = new EventoService();

  constructor(public readonly loginFilter: LoginFilter) {
    super();
  }

  async logar(dispositivoLogin: any, onSuccess: (dispositivo: any) => void) {
    if (
      !this.loginFilter.usuario ||
      this.loginFilter.usuario.length === 0 ||
      !this.loginFilter.senha ||
      this.loginFilter.senha.length === 0
    ) {
      return ToastService.showError("Informe o Login da rede e a Senha");
    }

    encerrarSessaoEventoInterno();

    try {
      this.blockUIService.start();
      const data: any = await this.loginService.login(
        this.loginFilter.usuario,
        this.loginFilter.senha
      );

      if (!data?.success) {
        ToastService.showError(data?.result?.[0] ?? "Falha ao autenticar");
        return;
      }

      const user = data.result;
      const login =
        user.preferredUsername ?? user.username ?? this.loginFilter.usuario;
      const idEvento =
        dispositivoLogin?.codAudienciaPublica ??
        sessionStorage.getItem("idEventoInterno");

      configurarSessaoEventoInterno({
        accessToken: user.accessToken,
        login,
        idEvento,
      });

      await this.configurarMembro(login);
      onSuccess(dispositivoLogin);
    } catch (err) {
      console.error(err);
      ToastService.showError(
        "Não foi possível realizar o login. Tente novamente."
      );
    } finally {
      this.blockUIService.stop();
    }
  }

  private async configurarMembro(login: string) {
    try {
      const res: any = await this.eventoService.getCpfUsuarioInterno(login);
      const cpf = res?.result?.[0]?.cpf;
      if (!cpf) return;

      const membroRes: any = await this.eventoService.getMembroInterno(cpf);
      const membro = membroRes?.result?.[0];

      sessionStorage.setItem(
        "membro",
        JSON.stringify({
          ...membro,
          cpf,
          codContribuinte: membro?.codContribuinte ?? null,
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}
